import { render, staticRenderFns } from "./StandardAccountEdit.vue?vue&type=template&id=2c8928e2&scoped=true&lang=pug"
import script from "./StandardAccountEdit.vue?vue&type=script&lang=ts"
export * from "./StandardAccountEdit.vue?vue&type=script&lang=ts"
import style0 from "./StandardAccountEdit.vue?vue&type=style&index=0&id=2c8928e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8928e2",
  null
  
)

export default component.exports